module.exports = __webpack_public_path__ + "media/images/user-6b0c252c910e06779739c467092c3cab.png";